export const truncateDecimals = (value: number, decimals: number) => {
  const multiplier = 10 ** decimals;

  return Math.round(value * multiplier) / multiplier;
};
